import React, { Component } from 'react';

import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { syncHistoryWithStore } from 'react-router-redux';
import { initialize, addTranslationForLanguage } from 'react-localize-redux';
import store from './Store';
import DefaultLanguageFronUrl from './localeAssets/DefaultLanguageFronUrl'
import Routes from './routes';

import { en_US, fr_FR } from './localeAssets'


const history = syncHistoryWithStore(createBrowserHistory(), store);

const languages = ['en_US', 'fr_FR'];
store.dispatch(initialize(languages, { defaultLanguage: DefaultLanguageFronUrl() }));
store.dispatch(addTranslationForLanguage(fr_FR, 'fr_FR'));
store.dispatch(addTranslationForLanguage(en_US, 'en_US'));


class App extends Component {
  render() {
    return (
      <div >
      <Provider store={store}>
        <Routes history={history} onUpdate={() => {
          window.scrollTo(0, 0)
        }} />
      </Provider>
      </div>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js